import React from 'react';

import type { ResultItemProps } from '@vlabs/pages/checks/components/result-item/ResultItem';
import { ResultItem } from '@vlabs/pages/checks/components/result-item/ResultItem';

import { Score } from './Score';

export interface BaseResultItemProps extends ResultItemProps {
  tag: React.ReactNode;
  score?: number;
}

function BaseResultItem({
  children = undefined,
  label,
  tag,
  score = undefined,
}: BaseResultItemProps): React.JSX.Element {
  return (
    <React.Fragment>
      <ResultItem label={label}>
        <Score value={score} />
        {tag}
      </ResultItem>

      {children}
    </React.Fragment>
  );
}

export { BaseResultItem };
